import axios from "axios";
import authHeader from "./auth-header";
import Config from "../config/index";

class SystemSettingsService {

    async getSystemSettings() {
        return await axios.get(Config.apiBasePath + "/getSystemSettings", {headers: authHeader()});
    }

    async getSystemSettingsOnly() {
        return await axios.get(Config.apiBasePath + "/getSystemSettingsOnly", {headers: authHeader()});
    }

    async getPlugins() {
        return await axios.get(Config.apiBasePath + "/getPlugins", {headers: authHeader()});
    }

    async getSystemSettingsWithoutAuth() {
        return await axios.post(Config.apiPortalBasePath + "/getSystemSettings", {}, {headers: authHeader()});
    }

    async saveSystemSettings(system_setting) {
        return axios.post(Config.apiBasePath + '/saveSystemSettings', system_setting, {
            headers: {
                ...authHeader()
            }
        });

    }


}

export default new SystemSettingsService();